import { render } from "./App.vue?vue&type=template&id=c3236190"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c3236190&lang=less"

import exportComponent from "D:\\项目\\云影像-王官营\\medical-imaging-doctor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__